// extracted by mini-css-extract-plugin
module.exports = {"reasoncontainer":"styles_reasoncontainer__aHOGp","checkbox":"styles_checkbox__GU1_H","reason":"styles_reason__uxz0u"};